const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://zrkd5e09sl.execute-api.eu-west-1.amazonaws.com';

export const API_ENDPOINTS = {
  GET_ADMINS: `${API_BASE_URL}/get_admins`,
  INSERT_ADMIN: `${API_BASE_URL}/insert_admin`,
  UPDATE_ADMIN: (email) => `${API_BASE_URL}/update_admin/${email}`,
  DELETE_ADMIN: (email) => `${API_BASE_URL}/delete_admin/${email}`,
  GET_ADMIN: (email) => `${API_BASE_URL}/get_admin/${email}`,
  
  GET_MEETINGS: `${API_BASE_URL}/meetings`,
  CREATE_MEETING: `${API_BASE_URL}/meetings`,
  UPDATE_MEETING: (id) => `${API_BASE_URL}/meetings/${id}`,
  DELETE_MEETING: (id) => `${API_BASE_URL}/meetings/${id}`,
  RSVP_MEETING: (id) => `${API_BASE_URL}/meetings/${id}/rsvp`,
  CANCEL_RSVP: (id) => `${API_BASE_URL}/meetings/${id}/cancel-rsvp`,
  
  GET_TOKEN: `${API_BASE_URL}/get_token`,
};

export const API_CONFIG = {
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
};

export const buildUrl = (endpoint, params = {}) => {
  const url = new URL(endpoint);
  Object.keys(params).forEach(key => {
    if (params[key] !== undefined && params[key] !== null) {
      url.searchParams.append(key, params[key]);
    }
  });
  return url.toString();
};

export const isDevelopment = process.env.NODE_ENV === 'development';
export const isProduction = process.env.NODE_ENV === 'production'; 